import { useFormContext } from 'react-hook-form';

import { DocumentController } from '@/components/Shared/ui';
import { useAppSelector } from '@/store';
import type { TDocumentsOnModeration } from '@/types/uploadFiles';

import {
  type FormType,
  fileDict,
  type fileDictType,
  financingItems
} from '../../features/euras-bank';

interface IProps {
  isPledgeMissing: boolean;
  isPledgeRegister: boolean;
  documentsOnModeration: TDocumentsOnModeration[];
}

const EurasDocuments: React.FC<IProps> = ({
  isPledgeMissing,
  isPledgeRegister,
  documentsOnModeration
}) => {
  const { orderApp } = useAppSelector((state) => state.newOrder);
  const { selectedBank } = useAppSelector((state) => state.financingStep);

  const { control } = useFormContext<FormType>();

  const kaskoProducts = orderApp?.productInfo?.additionalProducts
    ? orderApp.productInfo.additionalProducts.filter(
        (prod) => prod.checked && prod.label === 'Каско СК "Евразия"'
      )
    : [];
  const isSinglePerson = orderApp?.personalInfo?.familyStatus === 2;

  return financingItems
    .filter((item) =>
      selectedBank?.status.code === 'on_rework'
        ? documentsOnModeration.some(
            (docItem) =>
              docItem.documentType === null || docItem.documentType === item.key
          )
        : true
    )
    .map((item) => {
      let isFieldRequired = true;

      const isMarriageDocumentsNotRequired =
        (item.label === fileDict.VNES || item.label === fileDict.doc47) &&
        isSinglePerson;
      const isKaskoNotRequired =
        item.label === fileDict.KASKO && kaskoProducts.length === 0;
      const isHasInitialPayment =
        (Number(orderApp?.productInfo.product.initFee.replace(/\D/g, '')) ||
          0) !== 0;

      if (
        isMarriageDocumentsNotRequired ||
        isKaskoNotRequired ||
        item.label === fileDict.EM080 ||
        (item.label === fileDict.KVPV && !isHasInitialPayment)
      ) {
        isFieldRequired = false;
      }

      if (
        (item.label === fileDict.KASKO &&
          isPledgeMissing &&
          Number(orderApp?.productInfo.product.initFee) !== 0) ||
        (item.label === fileDict.KASKO && !isPledgeMissing) ||
        (!isPledgeRegister && item.label === fileDict.AREST)
      ) {
        return null;
      }

      return (
        <DocumentController
          key={item.key}
          control={control}
          name={item.key}
          title={fileDict[item.key as fileDictType] || ''}
          uploadable
          isRequired={isFieldRequired}
        />
      );
    });
};

export default EurasDocuments;
